module.exports = __webpack_public_path__ + "static/media/home.22d500b2.png";